import React from 'react';
import { Grid, Typography, Link } from '@material-ui/core';
import { Facebook, YouTube, Instagram } from '@material-ui/icons';
import { colors } from '../../constants.js/colors';
import { AuthFooterContainer, AuthFooterSocialsContainer } from '../AuthForm/AuthForm.style';
import Logo from '../../assets/img/Logo-Horizontal.svg';

const AuthFooter = () => {
    return (
        <AuthFooterContainer>
            <Grid container justify="space-between" style={{ gap: '24px' }}>
                <Grid item xs={12}>
                    <Link to="/" color="inherit">
                        <img src={Logo} alt="Logo" />
                    </Link>
                </Grid>
                <Grid container justify="center" alignItems="center" style={{ gap: '12px' }}>
                    <Grid
                        item
                        justify="center"
                        xs={12}
                        sm={3}
                        style={{ display: 'flex', gap: '12px' }}
                    >
                        <AuthFooterSocialsContainer
                            href="https://www.facebook.com/share/16asva29j1/?mibextid=wwXIfr"
                            color="inherit"
                        >
                            <Facebook />
                        </AuthFooterSocialsContainer>
                        <AuthFooterSocialsContainer
                            href="https://youtube.com/@ecometri?si=3P8NFHFzfaZrqSJf"
                            color="inherit"
                        >
                            <YouTube />
                        </AuthFooterSocialsContainer>
                        <AuthFooterSocialsContainer
                            href="https://www.instagram.com/ecometri?igsh=NzI5Mmk0ZzhocDNv"
                            color="inherit"
                        >
                            <Instagram />
                        </AuthFooterSocialsContainer>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Typography
                            variant="body2"
                            style={{ color: colors.white, fontWeight: 700 }}
                        >
                            Contacto
                        </Typography>
                        <Typography variant="body2" style={{ color: colors.neutral[300] }}>
                            <Link
                                href="https://wa.me/17543296020"
                                style={{ color: colors.neutral[300] }}
                            >
                                +1 (754) 329-6020
                            </Link>
                        </Typography>
                        <Typography variant="body2" style={{ color: colors.neutral[300] }}>
                            <Link
                                href="mailto:marketing@ecometri.com"
                                style={{ color: colors.neutral[300] }}
                            >
                                marketing@ecometri.com
                            </Link>
                        </Typography>
                        <Typography variant="body2" style={{ color: colors.neutral[300] }}>
                            NIT: 901754149-2
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Typography
                            variant="body2"
                            style={{ color: colors.white, fontWeight: 700 }}
                        >
                            Ubicación
                        </Typography>
                        <Typography variant="body2" style={{ color: colors.neutral[300] }}>
                            Calle 7D #43c-105
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </AuthFooterContainer>
    );
};

export default AuthFooter;
